
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AppHome.css";
import "../Admin/Admin.css";
import Header from "../Home/Header";
import { MdEdit, MdDelete } from "react-icons/md";
import DialogBox from "../Home/DialogBox";

const BASE_URL = "https://gym-invoice-back.onrender.com";

function ExpenditurePage() {

  const navigate = useNavigate();

  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    cost: "",
    date: "",
    description: "",
    branchCode: "",
  });

  const [expenditures, setExpenditures] = useState([]);

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    name: "",
    branchCode: "",
  });

  const [dialog, setDialog] = useState({
    show: false,
    type: "confirm",
    title: "",
    message: "",
    onConfirm: null,
  });

  const expenditureOptions = [
    "Electricity Bill",
    "Water Bill",
    "Equipment Repair",
    "Salaries",
    "Maintenance",
    "Rent",
    "Cleaning Supplies",
    "Others",
  ];


  // =========================================================
  // LOGIN CHECK
  // =========================================================
  useEffect(() => {

    const role = sessionStorage.getItem("userRole");

    if (!role) {
      navigate("/");
    }

  }, [navigate]);


  // =========================================================
  // GET LOGIN USER BRANCH
  // =========================================================
  const loggedUserBranch =
    sessionStorage.getItem("branchCode") || "";


  // =========================================================
  // FETCH EXPENDITURES
  // =========================================================
  useEffect(() => {
    fetchExpenditures();
  }, []);


  const fetchExpenditures = async () => {

    try {

      const res = await axios.get(
        `${BASE_URL}/api/expenditures`
      );

      setExpenditures(res.data);

    } catch (error) {

      console.error(
        "Failed to fetch expenditures",
        error
      );

    }
  };


  // =========================================================
  // HANDLE FORM INPUT
  // =========================================================
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };


  // =========================================================
  // HANDLE FILTER INPUT
  // =========================================================
  const handleFilterChange = (e) => {

    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });

  };


  // =========================================================
  // CLIENT SIDE FILTER
  // =========================================================
  const filteredExpenditures = expenditures
    .filter((exp) => {

      const expDate = exp.date
        ? new Date(exp.date)
        : null;

      const fromDate = filters.fromDate
        ? new Date(filters.fromDate)
        : null;

      const toDate = filters.toDate
        ? new Date(filters.toDate)
        : null;


      // Date From
      if (
        fromDate &&
        expDate &&
        expDate < fromDate
      ) {
        return false;
      }


      // Date To
      if (
        toDate &&
        expDate &&
        expDate > toDate
      ) {
        return false;
      }


      // Name
      if (
        filters.name &&
        !(
          exp.name || ""
        )
          .toLowerCase()
          .includes(
            filters.name.toLowerCase()
          )
      ) {
        return false;
      }


      // Branch
      if (
        filters.branchCode &&
        (exp.branchCode || "").toUpperCase() !==
          filters.branchCode.toUpperCase()
      ) {
        return false;
      }


      return true;

    })
    .sort(
      (a, b) =>
        new Date(b.date) -
        new Date(a.date)
    );


  // =========================================================
  // CLEAR FILTER
  // =========================================================
  const clearFilter = () => {

    setFilters({
      fromDate: "",
      toDate: "",
      name: "",
      branchCode: "",
    });

  };


  // =========================================================
  // EDIT
  // =========================================================
  const handleEditClick = (exp) => {

    setDialog({

      show: true,

      type: "confirm",

      title: "Edit Expenditure",

      message:
        `Do you want to edit "${exp.name}"?`,

      onConfirm: () => {

        setFormData({

          name: exp.name || "",

          cost: exp.cost || "",

          date: exp.date || "",

          description:
            exp.description || "",

          branchCode:
            exp.branchCode ||
            loggedUserBranch ||
            "",

        });

        setEditId(exp.id);

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

      },

    });

  };


  // =========================================================
  // DELETE
  // =========================================================
  const handleDelete = (id, name) => {

    setDialog({

      show: true,

      type: "confirm",

      title: "Delete Expenditure",

      message:
        `Are you sure you want to delete "${name}"?`,

      onConfirm: async () => {

        try {

          await axios.delete(
            `${BASE_URL}/api/expenditures/${id}`
          );

          fetchExpenditures();

        } catch (error) {

          console.error(
            "Failed to delete expenditure",
            error
          );

        }

      },

    });

  };


  // =========================================================
  // ADD / UPDATE
  // =========================================================
  const handleSubmit = (e) => {

    e.preventDefault();


    // Branch must exist
    if (!formData.branchCode) {

      alert(
        "Branch Code is required."
      );

      return;
    }


    setDialog({

      show: true,

      type: "confirm",

      title:
        editId
          ? "Update Expenditure"
          : "Add Expenditure",

      message:
        editId
          ? `Do you want to update "${formData.name}"?`
          : `Do you want to add "${formData.name}"?`,

      onConfirm: async () => {

        try {

          const payload = {

            name: formData.name,

            cost: Number(formData.cost),

            date: formData.date,

            description:
              formData.description,

            branchCode:
              formData.branchCode
                .trim()
                .toUpperCase(),

          };


          // UPDATE
          if (editId) {

            await axios.put(

              `${BASE_URL}/api/expenditures/${editId}`,

              payload

            );

          }

          // ADD
          else {

            await axios.post(

              `${BASE_URL}/api/expenditures`,

              payload

            );

          }


          // Reset
          setFormData({

            name: "",

            cost: "",

            date: "",

            description: "",

            branchCode:
              loggedUserBranch || "",

          });

          setEditId(null);

          fetchExpenditures();


        } catch (error) {

          console.error(
            "Error saving expenditure",
            error
          );

          alert(
            "Error saving expenditure."
          );

        }

      },

    });

  };


  // =========================================================
  // INITIAL FORM BRANCH
  // =========================================================
  useEffect(() => {

    if (loggedUserBranch) {

      setFormData((prev) => ({

        ...prev,

        branchCode:
          prev.branchCode ||
          loggedUserBranch,

      }));

    }

  }, [loggedUserBranch]);


  return (

    <div className="dashboard">

      <Header />

      <div className="payment-container">

        <h2>
          💰 Expenses Management
        </h2>


        {/* ================================================= */}
        {/* FORM */}
        {/* ================================================= */}

        <div className="main-card-payment">

          <form
            className="payment-card"
            onSubmit={handleSubmit}
          >

            <h2>
              📝 Add / Edit Expenditure
            </h2>


            <select
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            >

              <option value="">
                Select Expenditure
              </option>

              {expenditureOptions.map(
                (opt) => (

                  <option
                    key={opt}
                    value={opt}
                  >
                    {opt}
                  </option>

                )
              )}

            </select>


            <input
              type="number"
              name="cost"
              placeholder="Cost (Rs)"
              value={formData.cost}
              onChange={handleChange}
              min="0"
              step="0.01"
              required
            />


            <label>
              Select Date
            </label>

            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />


            <input
              type="text"
              name="description"
              placeholder="Description"
              value={formData.description}
              onChange={handleChange}
            />


            {/* BRANCH CODE */}
            <label>
              Branch Code
            </label>

            <select
              name="branchCode"
              value={formData.branchCode}
              onChange={handleChange}
              required
            >

              <option value="">
                Select Branch
              </option>

              <option value="KB">
                KB
              </option>

              <option value="WB">
                WB
              </option>

            </select>


            <div className="filter-buttons">

              <button
                type="submit"
                className="btn btn-primary"
              >

                {editId
                  ? "💾 Update"
                  : "➕ Add"}

              </button>


              {editId && (

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {

                    setEditId(null);

                    setFormData({

                      name: "",

                      cost: "",

                      date: "",

                      description: "",

                      branchCode:
                        loggedUserBranch || "",

                    });

                  }}
                >
                  Cancel
                </button>

              )}

            </div>

          </form>


          {/* ================================================= */}
          {/* FILTERS */}
          {/* ================================================= */}

          <div className="payment-card">

            <h2>
              🔍 Search Expenditure
            </h2>


            <label>
              Select Date From
            </label>

            <input
              type="date"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleFilterChange}
            />


            <label>
              Select Date To
            </label>

            <input
              type="date"
              name="toDate"
              value={filters.toDate}
              onChange={handleFilterChange}
            />


            <input
              type="text"
              name="name"
              placeholder="Expenditure Name"
              value={filters.name}
              onChange={handleFilterChange}
            />


            {/* BRANCH FILTER */}
            <label>
              Branch Code
            </label>

            <select
              name="branchCode"
              value={filters.branchCode}
              onChange={handleFilterChange}
            >

              <option value="">
                ALL BRANCHES
              </option>

              <option value="KB">
                KB
              </option>

              <option value="WB">
                WB
              </option>

            </select>


            <div className="filter-buttons">

              <button
                type="button"
                onClick={clearFilter}
                className="btn btn-primary"
              >
                Clear
              </button>

            </div>

          </div>

        </div>


        {/* ================================================= */}
        {/* TABLE */}
        {/* ================================================= */}

        <table className="payment-table">

          <thead>

            <tr>

              <th>No</th>

              <th>Expenditure Name</th>

              <th>Branch Code</th>

              <th>Cost (Rs)</th>

              <th>Date</th>

              <th>Description</th>

              <th>Action</th>

            </tr>

          </thead>


          <tbody>

            {filteredExpenditures.length > 0 ? (

              filteredExpenditures.map(
                (e, i) => (

                  <tr key={e.id}>

                    <td>
                      {i + 1}
                    </td>

                    <td>
                      {e.name}
                    </td>

                    <td>
                      {e.branchCode || "-"}
                    </td>

                    <td>
                      {Number(
                        e.cost || 0
                      ).toLocaleString(
                        "en-LK",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </td>

                    <td>
                      {e.date
                        ? new Date(
                            e.date
                          ).toLocaleDateString(
                            "en-GB"
                          )
                        : ""}
                    </td>

                    <td>
                      {e.description}
                    </td>

                    <td>

                      <div className="table-action-buttons">

                        <button
                          onClick={() =>
                            handleEditClick(e)
                          }
                          className="action-btn edit-btn"
                        >

                          <MdEdit size={20} />

                          Edit

                        </button>


                        <button
                          onClick={() =>
                            handleDelete(
                              e.id,
                              e.name
                            )
                          }
                          className="action-btn delete-btn"
                        >

                          <MdDelete size={20} />

                          Delete

                        </button>

                      </div>

                    </td>

                  </tr>

                )

              )

            ) : (

              <tr>

                <td
                  colSpan="7"
                  style={{
                    textAlign: "center",
                  }}
                >
                  No records found
                </td>

              </tr>

            )}

          </tbody>

        </table>


        {/* ================================================= */}
        {/* DIALOG */}
        {/* ================================================= */}

        <DialogBox
          dialog={dialog}
          setDialog={setDialog}
        />

      </div>

    </div>

  );
}

export default ExpenditurePage;

